import { createContext, useContext } from 'react';

export type IOnAccountEditCallback = (id?: string) => void;

export const AccountUpdateContext = createContext<IOnAccountEditCallback>(() => void 0);

export const AccountUpdateProvider = AccountUpdateContext.Provider;

export const useOnAccountUpdate = () => useContext(AccountUpdateContext);
